import React from 'react'
import { RepresentativeContainer } from '@/components/containers/representative'
import { useTitle } from '@/hooks/use-title'
import SettingsIcon from '@material-ui/icons/Settings'

export const RepresentativePage: React.FC = () => {
  useTitle('設定 / 担当者情報', <SettingsIcon />)
  return <RepresentativeContainer />
}
